import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.newsItem)?_c(VCard,[_c(VImg,{staticClass:"mb-4",attrs:{"src":_vm.newsItem.media[0].url,"alt":"News Image","max-height":"300"}}),_c(VCardTitle,{staticClass:"text-break"},[_vm._v(_vm._s(_vm.newsItem.title))]),_c(VCardSubtitle,[_vm._v(_vm._s(_vm.moment(_vm.newsItem.pubDate).format("DD.MM.YYYY")))]),_c(VCardText,{domProps:{"innerHTML":_vm._s(_vm.newsItem.description)}}),_c(VCardActions,[_c(VBtn,{attrs:{"color":"primary","text":""},on:{"click":function($event){}}},[_vm._v(" Weiterlesen ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }